@if (pricelist$ | async; as pricelist) {
<mat-dialog-content>
    <div id="pricelist-info" class="display-flex">
        <div class="pricelist-info-col">
            <div class="pricelist-info-item">
                <div class="label">Data utworzenia</div>
                <div class="value">{{pricelist.createDate | date:'dd-MM-yyyy'}}</div>
            </div>
        </div>
        <div class="pricelist-info-col">
            <div class="pricelist-info-item">
                <div class="label">Ważny od</div>
                <div class="value">{{pricelist.validFrom | date:'dd-MM-yyyy'}}</div>
            </div>
        </div>
        <div class="pricelist-info-col">
            <div class="pricelist-info-item">
                <div class="label">Ważny do</div>
                <div class="value" [class.expired]="!isActive(pricelist)">
                    {{pricelist.validTo ? (pricelist.validTo | date:'dd-MM-yyyy') : 'Bezterminowo'}}
                </div>
            </div>
        </div>
    </div>
    <div class="label section-label">Taryfy</div>
    <mat-table [dataSource]="pricelist.tariffs" id="tariffs-table" class="mat-elevation-z8">
        <ng-container matColumnDef="tier">
            <mat-header-cell *matHeaderCellDef>Tier</mat-header-cell>
            <mat-cell *matCellDef="let tariff">{{tariff.tier}}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
            <mat-cell *matCellDef="let tariff">{{tariff.name}}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef class="price-cell">Cena</mat-header-cell>
            <mat-cell *matCellDef="let tariff" class="price-cell">{{tariff.price | currency:'PLN'}}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="price-cell">Cena za dodatkową jednostkę</mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="orders">
            <mat-header-cell *matHeaderCellDef>Zamówienia</mat-header-cell>
            <mat-cell *matCellDef="let tariff">{{tariff.orders.from}} — {{tariff.orders.to}}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{pricelist.extraPrices.orders | currency:'PLN'}}</mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="products">
            <mat-header-cell *matHeaderCellDef>Produkty</mat-header-cell>
            <mat-cell *matCellDef="let tariff">{{tariff.products.from}} — {{tariff.products.to}}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{pricelist.extraPrices.products | currency:'PLN'}}</mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="auctions">
            <mat-header-cell *matHeaderCellDef>Aukcje</mat-header-cell>
            <mat-cell *matCellDef="let tariff">{{tariff.auctions.from}} — {{tariff.auctions.to}}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{pricelist.extraPrices.auctions | currency:'PLN'}}</mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="shipments">
            <mat-header-cell *matHeaderCellDef>Przesyłki</mat-header-cell>
            <mat-cell *matCellDef="let tariff">{{tariff.shipments.from}} — {{tariff.shipments.to}}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{pricelist.extraPrices.shipments | currency:'PLN'}}</mat-footer-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="['tier', 'name', 'price', 'orders', 'products', 'auctions', 'shipments']" class="table-header"></mat-header-row>
        <mat-row *matRowDef="let tariff; columns: ['tier', 'name', 'price', 'orders', 'products', 'auctions', 'shipments']"></mat-row>
        <mat-footer-row *matFooterRowDef="['tier', 'name', 'price', 'orders', 'products', 'auctions', 'shipments']" class="extra-prices-row"></mat-footer-row>
    </mat-table>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton color="warn" (click)="deletePricelist()">Usuń</button>
    <button mat-flat-button color="primary" (click)="editPricelist()">Edytuj</button>
</mat-dialog-actions>
}
